import React from 'react';
// import classes from './DisabledCustomizedPost.module.scss';
import classes from '../../../components/containers/Accordion/AccordionTitle/AccordionTitle.module.scss';
import { Icon } from '../../../components/images/Icon/Icon';
import { BreakpointsValuesEnum } from '../../../constants/breakpoints-values';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import classNames from 'classnames';
import { IconsEnum } from '../../../constants/icons';
import { MandatoryChildren } from '../../../models/children-props';

export type DisabledCustomizedPostViewProps = MandatoryChildren<{
  //
  isFirst: boolean;
  accordionIcon: IconsEnum;
  tabindex: number;
}>;

export const DisabledCustomizedPostView = (props: DisabledCustomizedPostViewProps): JSX.Element => {
  const { accordionIcon, isFirst, tabindex, children } = props;
  const breakpoint: keyof typeof BreakpointsValuesEnum = useBreakpoints();

  const globalClasses = classNames(classes.AccordionTitle, {
    [classes.AccordionTitleFirst]: isFirst,
    [classes.AccordionTitleDesktop]: breakpoint !== 'small' && breakpoint !== 'medium',
    [classes.AccordionTitleDisabled]: true
  });

  const iconWrapperClasses = classNames(
    classes.AccordionTitleWrapper,
    'align-self-stretch',
    'grid-y',
    'align-center',
    'relative',
    classes.AccordionTitleIconWrapper,
    classes.AccordionTitleSegmented
  );
  const mainWrapperClasses = classNames('cell', 'auto', classes.AccordionTitleWrapper);

  return (
    <div className={globalClasses} aria-disabled={true} aria-expanded={false} tabIndex={tabindex} role={'button'}>
      <div className={'grid-x align-justify align-middle'}>
        <div className={mainWrapperClasses}>{children}</div>
        <div className={iconWrapperClasses}>
          <div className={classes.IconWrapper}>
            <Icon name={accordionIcon} size={'medium'} />
          </div>
        </div>
      </div>
    </div>
  );
};
